<template>
  <div>
    <div class="content" style="width: auto">
      <div class="cont-list">
        <span class="list">{{ this.parentRoute.menuName }}-{{ title }}{{ typeName }}</span>
      </div>
      <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
        <div class="edit-card">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">计量基础信息</span>
          </div>
          <el-row>
            <el-col :span="6">
              <el-form-item label="计量编号" prop="no">
                <el-input disabled v-model="form.no" placeholder="系统自动生成计量编号" style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="计量名称" prop="name">
                <el-input :disabled="!editMode" v-model="form.name" placeholder="请填写计量名称" style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="计量单位" prop="unitName">
                <el-input :disabled="!editMode" v-model="form.unitName" placeholder="请填写计量单位" style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="单位联系人" prop="contactor">
                <el-input :disabled="!editMode" v-model="form.contactor" placeholder="请输入单位联系人" style="width: 90%" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="联系方式" prop="phone">
                <el-input :disabled="!editMode" v-model="form.phone" placeholder="请输入联系方式" style="width: 90%" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="计量日期" prop="date">
                <el-date-picker :disabled="!editMode" v-model="form.date" :picker-options="pickerOptions" style="width: 90%" type="date" value-format="yyyy-MM-dd" placeholder="请选择预计下次日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="计量费用" prop="totalAmount">
                <el-input-number disabled v-model="form.totalAmount" :min="0" :precision="4" :controls="false" placeholder="请填写计量费用" style="width: 90%"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="计量工时(人/小时)" prop="hour">
                <el-input-number :disabled="!editMode" v-model="form.hour" :min="0" :precision="2" :controls="false" placeholder="请填写计量工时" style="width: 90%"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="计量责任科室" prop="dutyDeptName">
                <el-select :disabled="!editMode" v-model="form.dutyDeptName" style="width: 90%" filterable placeholder="请选择计量责任科室" :filter-method="getDepts" @change="deptChange">
                  <el-option v-for="item in STATIC_Depts" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="计量责任人" prop="dutyUserName">
                <el-select :disabled="!editMode" v-model="form.dutyUserName" style="width: 90%" filterable placeholder="请选择计量责任人" :filter-method="getUsersByDept" @change="dutyUserChange">
                  <el-option v-for="item in STATIC_DeptUsers" :key="item.id" :label="item.no + ' ' + item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="创建人" prop="createdUserName">
                <el-input v-model="form.createdUserName" disabled style="width: 90%" placeholder="系统默认为当前操作人员"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="创建时间" prop="createdTime">
                <el-date-picker disabled v-model="form.createdTime" style="width: 90%" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="系统默认为当前时间">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <template v-for="(item, index) in form.certDetails">
            <el-row :key="index">
              <el-row>
                <el-col :span="6">
                  <el-form-item>
                    <label slot="label">
                      <span>{{
                        "计量证书编码(" +
                          Arabia_To_SimplifiedChinese(index + 1) +
                          ")"
                      }}</span>
                      <span v-if="editMode" style="margin-left: 20px" class="color-blue pointer" type="text" v-preventReClick @click="removeCertificate(item)">删除</span>
                    </label>
                    <el-input :disabled="!editMode" v-model="item.no" placeholder="请填写证书编码" style="width: 90%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="证书名称">
                    <el-input :disabled="!editMode" v-model="item.name" placeholder="请填写证书名称" style="width: 90%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="证书生效日期">
                    <el-date-picker :disabled="!editMode" v-model="item.startDate" style="width: 90%" type="date" @change="dateChange(item, 0)" value-format="yyyy-MM-dd" placeholder="请选择证书生效日期">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="证书失效日期">
                    <el-date-picker :disabled="!editMode" v-model="item.endDate" style="width: 90%" type="date" @change="dateChange(item, 1)" value-format="yyyy-MM-dd" placeholder="请选择证书失效日期" :picker-options="{
                        disabledDate(v) {
                          return disabledDateFun(v, item);
                        },
                      }">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24" style="display: flex">
                  <UploadFileList label="上传证书" :fileList="item.fileInfos ? [item.fileInfos[0]] : []" btnShowType="always" :multipleFile="false" :showFileList="false" :editMode="editMode" @fileChange="certFileChange($event, item)"></UploadFileList>
                  <div class="certificateState">
                    证书状态：<span v-html="isEffective(item)"></span>
                  </div>
                </el-col>
              </el-row>
            </el-row>
          </template>
          <el-row v-show="showAddCertificate">
            <el-col>
              <div class="addCertificateBtn">
                <img src="@/assets/shizi.png" alt="" v-preventReClick @click="addCertificate" />
                <span v-preventReClick @click="addCertificate"> 添加证书 </span>
              </div>
            </el-col>
          </el-row>
          <el-row style="margin-top: 20px"></el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="计量说明" prop="desc">
                <el-input :disabled="!editMode" v-model="form.desc" placeholder="请填写计量说明" type="textarea" resize="none" :rows="5" style="width: 95%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="备注" prop="remark">
                <el-input :disabled="!editMode" v-model="form.remark" placeholder="请填写备注" type="textarea" resize="none" :rows="5" style="width: 95%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="" label-width="0" prop="fileInfos">
              </el-form-item>
              <UploadFileList :fileList="form.fileInfos" btnShowType="always" :editMode="editMode" @fileChange="fileChange"></UploadFileList>
            </el-col>
          </el-row>
          <el-row style="margin-top: 20px"></el-row>
        </div>

        <InvoiceEdit></InvoiceEdit>

        <AssetInfoEdit ref="AssetInfoEditRef" :data="form.details" :canEdit="editMode" :ParentForm="form" :FixedAssetParam="{ deptId: form.deptId, isMeteringSign: 1 }" :AssetCardsParam="{ category: '1', isMeteringSign: 1 }" :isWorkOrder="true" :isMetering="true" :showFileList="false" WorkOrderAmountName="计量" :showDimension="true" @autoTotalAmount="autoTotalAmount" :getFixedAssetListMethod="getAssetCardsMethod" :moreColumn="moreColumn" :isRepeatMethod="isRepeatMethod" isRepeatMsg="当前资产信息已存在，请去子表编辑！">
          <el-table-column label="计量费用" slot="fees" width="240px" align="center" :formatter="toDecimal4">
            <template slot-scope="scope">
              <el-input-number v-if="editMode" v-model="scope.row.fees" :min="0" :precision="4" :controls="false" placeholder="计量费用" style="width:100%" @change="MeteringFeeChange"></el-input-number>
              <label v-else>{{ scope.row.fees }}</label>
            </template>
          </el-table-column>
          <el-table-column label="计量合格" slot="isOk" width="120px" align="center">
            <template slot-scope="scope">
              <el-select v-if="editMode" v-model="scope.row.isOk" placeholder="计量合格" style="width: 100%">
                <el-option v-for="item in WhetherOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
              <label v-else>{{ scope.row.isOk }}</label>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip label="计量结果" slot="result" width="240px" align="center">
            <template slot-scope="scope">
              <el-input v-if="editMode" v-model="scope.row.result" placeholder="计量结果" style="width:100%"></el-input>
              <label v-else>{{ scope.row.result }}</label>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip label="附件" slot="result" width="300px" align="center">
            <template slot-scope="scope">
              <div style="display:flex;align-items:center;">
                <el-upload v-if="editMode" style="width:50%" class="upload-demo" ref="upload" :show-file-list="false" :action="uploadAction" :accept="uploadFileType" :headers="uploadHeaders" :on-success="
                    (response, file, fileList) =>
                      onUploadSuccess(
                        response,
                        file,
                        fileList,
                        scope.row,
                        scope
                      )
                  ">
                  <el-button type="text">点击此处上传附件</el-button>
                </el-upload>
                <el-popover style="width:50%" placement="bottom" width="360" trigger="click">
                  <ul class="fileListUl_always" :key="'ul' + timeStamp">
                    <li class="fileItem" v-for="(item, index) in scope.row.fileInfos" :key="index">
                      <span class="fileName">{{ item.name }}</span>
                      <div class="btn_group" :class="editMode ? 'canedit' : ''">
                        <span v-preventReClick @click="privewImg(item)">
                          点击查看
                        </span>
                        <span v-preventReClick @click="downloadImg(item)">
                          下载
                        </span>
                        <span v-show="editMode" v-preventReClick @click="RemoveFile(item, scope.row)">
                          删除
                        </span>
                      </div>
                    </li>
                  </ul>
                  <span slot="reference" class="show-files">
                    查看附件
                    <i class="el-icon-caret-top"></i>
                  </span>
                </el-popover>
              </div>
            </template>
          </el-table-column>
        </AssetInfoEdit>
        <ApproveInfo ref="approveInfo" v-if="showWorkFlowInfo" @change="approveInfoChange"></ApproveInfo>
      </el-form>
    </div>
    <div slot="footer" class="footer-bottom">
      <el-button v-if="editMode" class="btn default" v-preventReClick @click="cancel">取 消</el-button>
      <my-button v-if="editMode" class="btn primary" type="primary" v-preventReClick @click="submit">确 定</my-button>
      <my-button v-if="showWorkFlowInfo" class="btn primary" type="primary" v-preventReClick @click="approve">确 定</my-button>
      <el-button v-if="!editMode" class="btn default" v-preventReClick @click="$router.go(-1)">返 回</el-button>
    </div>
    <el-image-viewer :openViewer="dialogVisible" :fileId="fileId" :fileName="fileName" @closeImageViewer="closeImageViewer" />
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import GetDataMixin from "@/mixin/getData-mixin.js";
import {
  GetMeteringById,
  RejectMetering,
  SaveMetering,
  GetAssetCardByIsMeteringSign,
  WorkFlowSubmitSaveMetering,
} from "@/api";
import { WarehouseOutStockOptions, WhetherOptions } from "@/enum";
import SelectTable from "@/components/select-table";
import ApproveInfo from "@/components/approve-info";
import AssetInfoEdit from "@/components/asset-into-edit";
import UploadFileList from "@/components/upload-file-list";
import InvoiceEdit from "@/components/invoice-edit";
import ElImageViewer from "@/components/elImageViewer";
import { Arabia_To_SimplifiedChinese } from "@/utils/number.js";
import { validPhone } from "@/utils/validate";
export default {
  mixins: [GetDataMixin],
  components: {
    SelectTable,
    ApproveInfo,
    AssetInfoEdit,
    UploadFileList,
    InvoiceEdit,
    ElImageViewer,
  },
  /** 定义属性 */
  data () {
    var validatePhone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("联系方式不能为空"));
      } else {
        if (validPhone(value)) {
          callback();
        } else {
          callback(new Error("联系方式有误"));
        }
      }
    };
    return {
      typeName: "计量",
      form: {},
      Arabia_To_SimplifiedChinese: Arabia_To_SimplifiedChinese,
      WarehouseOutStockOptions: WarehouseOutStockOptions,
      WhetherOptions: WhetherOptions,
      rules: {
        name: [
          { required: true, message: "计量名称不能为空", trigger: "blur" },
        ],
        unitName: [
          { required: true, message: "计量单位不能为空", trigger: "blur" },
        ],
        contactor: [
          { required: true, message: "单位联系人不能为空", trigger: "blur" },
        ],
        phone: [
          { required: true, message: "联系方式不能为空", trigger: "blur" },
          { validator: validatePhone, trigger: "blur" },
        ],
        date: [
          { required: true, message: "计量日期不能为空", trigger: "blur" },
        ],
        totalAmount: [
          { required: true, message: "计量费用不能为空", trigger: "blur" },
        ],
        hour: [
          { required: true, message: "计量工时不能为空", trigger: "blur" },
        ],
        dutyDeptName: [
          { required: true, message: "计量责任科室不能为空", trigger: "blur" },
        ],
        dutyUserName: [
          { required: true, message: "计量责任人不能为空", trigger: "blur" },
        ],
      },
      editMode: false,
      showWorkFlowInfo: false,
      assetList: [],
      reject: RejectMetering,
      pickerOptions: {
        disabledDate (v) {
          return (
            v.getTime() < new Date(new Date() - 1000 * 60 * 60 * 24).getTime()
          );
        },
      },
      showAddCertificate: true,
      moreColumn: [{ slot: "fees" }, { slot: "isOk" }, { slot: "result" }],
      dialogVisible: false,
      dialogImageUrl: "",
      fileName: "",
      fileId: 0,
      timeStamp: "",
    };
  },
  /** 计算属性，会监听依赖属性值随之变化 */
  computed: {},
  /** 监控data中的数据变化 */
  watch: {},
  /** 方法集合 */
  methods: {
    InitData () {
      var query = this.$route.query;
      if (query.id) {
        this.handleUpdate(query.id);
      } else {
        this.handleAdd();
      }
    },
    // 新建
    handleAdd () {
      this.resetForm();
      this.editMode = true;
    },
    // 编辑
    handleUpdate (id) {
      GetMeteringById({ id }).then((res) => {
        // this.resetForm()
        this.form = res.returnData;
        if (!this.form.details) {
          this.form.details = [];
        }
        this.form.details.forEach((e, index) => {
          e.$index = index + 1;
        });
        if (!this.form.certDetails) {
          this.form.certDetails = [];
        }
        this.form.certDetails.forEach((e, index) => {
          e.$index = index + 1;
        });
        this.$refs.AssetInfoEditRef.setDetalis(this.form.details);
        this.initWorkFlowProperty(this.form);
        this.form.details.forEach((e, index) => {
          e.$index = index + 1;
        });
      });
    },
    /**
     * 初始化表单
     */
    resetForm () {
      this.form = {
        createdUserName: this.userInfo.name,
        createdTime: this.parseTime(new Date(), "{y}-{m}-{d}"),
        date: this.parseTime(new Date(), "{y}-{m}-{d}"),
        warehouseId: null,
        warehouseName: null,
        warehouseManagerId: null,
        warehouseManagerName: null,
        backWarehouseId: null,
        backWarehouseName: null,
        backWarehouseManagerId: null,
        backWarehouseManagerName: null,
        userName: null,
        phone: null,
        toTalNumber: 0,
        totalAmount: 0,
        details: [],
        certDetails: [
          {
            $index: 1,
            no: "",
            name: "",
            date: "",
            endDate: "",
            fileInfos: null,
          },
        ],
        orgCode :sessionStorage.getItem('orgId')
      };
    },
    // 保存
    submit () {
      this.form.details = this.$refs.AssetInfoEditRef.getDetails();
      if (this.isBeforeToday()) {
        this.$my_confirm("证件失效日期小于等于当前日期，是否仍要保存？", {
          confirmButtonText: "继续",
          cancelButtonText: "取消",
          closeOnClickModal: false,
          type: "info",
        })
          .then(() => {
            // 继续创建
            this.save();
          })
          .catch(() => {
            return;
          });
      } else {
        this.save();
      }
    },
    save () {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
        if (this.formMode == "3") {
          WorkFlowSubmitSaveMetering(this.form).then((res) => {
            this.$my_message(`执行成功`, "success");
            sessionStorage.setItem("editMode", 0);
            this.$router.push({ path: this.getMainPath(this.$route.path) });
          }).finally(() => {
          this.$store.dispatch('SetLoading',false)
        });;
        } else {
          SaveMetering(this.form).then((res) => {
            this.$my_message(`执行成功`, "success");
            sessionStorage.setItem("editMode", 0);
            this.$router.push({ path: this.getMainPath(this.$route.path) });
          }).finally(() => {
          this.$store.dispatch('SetLoading',false)
        });;
        }
      });
    },
       // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      // this.$my_confirm("确认要中断当前操作吗？", "提示", {
      //   type: "warning",
      // }).then(() => {
      //   this.$router.go(-1);
      // });
      this.$router.push({ path: this.getMainPath(this.$route.path) });
    },
    /**
     * 原库房选择
     */
    warehouseChange (val) {
      let item = this.STATIC_Warehouses.find((e) => e.id == val);
      if (item) {
        this.form.warehouseId = item.id;
        this.form.warehouseManagerId = item.managerId;
        this.form.warehouseManagerName = item.managerName;
      }
    },
    /**
     * 调回库房选择
     */
    backWarehouseChange (val) {
      let item = this.STATIC_Warehouses.find((e) => e.id == val);
      if (item) {
        this.form.backWarehouseId = item.id;
        this.form.backWarehouseManagerId = item.managerId;
        this.form.backWarehouseManagerName = item.managerName;
      }
    },
    /**
     * 明细表添加
     */
    handleAddChildForm () {
      if (!this.form.details) {
        this.form.details = [];
      }
      this.openSubformModal = true;
      this.resetDetailFormData();
    },
    fileChange (e) {
      this.form.fileInfos = e;
    },
    certFileChange (e, item) {
      item.fileInfos = e;
    },
    getUsersByDept (keyWord) {
      return this.getDeptUsers(this.form.dutyDeptId, keyWord);
    },
    deptChange (val) {
      this.$set(this.form, "dutyDeptId", val);
      this.$set(this.form, "dutyUserId", null);
      this.$set(this.form, "dutyUserName", null);
      var item = this.STATIC_Depts.find((t) => t.id == val);
      if (item) {
        this.$set(this.form, "dutyUserId", item.leader);
        this.$set(this.form, "dutyUserName", item.leaderName);
      }
      this.getUsersByDept();
    },
    dutyUserChange (val) {
      this.form.dutyUserId = val;
    },
    addCertificate () {
      if (this.form.certDetails.length <= 5) {
        this.form.certDetails.push({
          $index: this.form.certDetails.length + 1,
          no: "",
          name: "",
          date: "",
          endDate: "",
          fileInfos: null,
        });
        this.showAddCertificate = true;
        if (this.form.certDetails.length == 5) this.showAddCertificate = false;
      } else {
        this.showAddCertificate = false;
      }
    },
    removeCertificate (item) {
      this.form.certDetails = this.form.certDetails.filter(
        (i) => item.$index != i.$index
      );
      this.form.certDetails.forEach((e, index) => {
        e.$index = index + 1;
      });
    },
    /**
     * 是否有效期内
     */
    isEffective (item) {
      if (item.date || item.endDate) {
        let now = new Date().getTime();
        if (
          now < new Date(item.date).getTime() ||
          now > new Date(item.endDate).getTime()
        ) {
          return "<span style='color:#E8873D;'>效期外</span>";
        } else {
          return "<span style='color:#6ea204;'>效期内</span>";
        }
      } else {
        return "<span style='color:#E8873D;'>效期外</span>";
      }
    },
    autoTotalAmount (e) {
      this.form.details = e;
      let toTalNumber = 0;
      let totalAmount = 0;
      this.form.details.forEach((element, index) => {
        // 重置表格数据的序号
        element.$index = index + 1;
        toTalNumber = toTalNumber * 1 + element.number * 1;
        totalAmount = totalAmount * 1 + element.fees * 1;
        e[index].unBillNumber = element.number;
        e[index].unBillAmount = element.fees;
      });
      this.form.toTalNumber = toTalNumber;
      this.form.totalAmount = totalAmount;
      this.form.unBillNumber = toTalNumber;
      this.form.unBillAmount = totalAmount;
    },
    /**
     * 时间选择
     */
    dateChange (item, index) {
      if (
        index == 0 &&
        item.endDate &&
        new Date(item.date) >= new Date(item.endDate)
      ) {
        // 开始时间修改，而且修改的时间大于结束时间时
        item.endDate = null;
      }
    },
    disabledDateFun (v, item) {
      return v.getTime() <= new Date(item.startDate).getTime();
    },
    isBeforeToday () {
      for (let i = 0; i < this.form.certDetails.length; i++) {
        const element = this.form.certDetails[i];
        if (element.endDate) {
          if (new Date(element.endDate).getTime() <= new Date().getTime()) {
            return true;
          }
        }
      }
    },
    getAssetCardsMethod () {
      return new Promise((resolve, reject) => {
        var param = {
          pageIndex: 1,
          pageSize: 1000000,
        };
        param = Object.assign(
          param,
          this.$refs.AssetInfoEditRef.getDimensionParam()
        );
        GetAssetCardByIsMeteringSign(param).then((response) => {
          if (response && response.returnData) {
            resolve(response.returnData.data);
          } else {
            reject(response);
          }
        });
      });
    },
    toDecimal4 (row, column, cellValue, index) {
      return "￥" + this.toDecimal(cellValue, 4);
    },
    toDecimal2 (row, column, cellValue, index) {
      return this.toDecimal(cellValue, 2);
    },
    fileValidate (file) {
      // if (file.size > 1024 * 1024 * 3) {
      //   this.$my_message(`图片大小超过3M,上传失败！`, "warning");
      //   return false;
      // }
      if (this.fileInfos.length == this.limit) {
        this.$my_message(
          `抱歉！当前上传附件总数已超过系统限制，请核实后再上传！`,
          "warning"
        );
        return false;
      }
      let size = 0;
      this.fileInfos.forEach((item) => {
        size += item.size;
      });
      if (size + file.size >= this.maxSize * 1024 * 1024) {
        this.$my_message(
          `抱歉！当前上传附件总大小已超过系统限制，请核实后再上传！`,
          "warning"
        );
        return false;
      }
    },
    MeteringFeeChange (e) {
      let totalAmount = 0;
      this.form.details.forEach((element, index) => {
        // 重置表格数据的序号
        totalAmount += element.fees;
      });
      this.form.totalAmount = totalAmount;
    },
    onUploadSuccess (response, file, fileList, row, scope) {
      response.returnData.forEach((item) => {
        // this.$set(this.form.details[scope.$index], "fileInfos", [item]);
        row.fileInfos = [item];
      });
      this.timeStamp = new Date().valueOf();
    },
    privewImg (file) {
      // this.dialogImageUrl = file.path;
      // this.dialogVisible = true;
      this.dialogVisible = true;
      this.fileId = file.id;
      this.fileName = file.name;
    },
    closeImageViewer () {
      this.dialogVisible = false;
    },
    RemoveFile (file, row) {
      var index = row.fileInfos.indexOf(file);
      if (index > -1) {
        row.fileInfos.splice(index, 1);
      }
    },
    isRepeatMethod (arr, row) {
      let item = arr.find(
        (e) =>
          e.$index != row.$index &&
          e.assetId == row.assetId &&
          e.price == row.price &&
          e.locationName == row.locationName &&
          e.assetSource == row.assetSource &&
          e.packDesc == row.packDesc &&
          e.manufacturerId == row.manufacturerId &&
          e.certId == row.certId &&
          e.brandId == row.brandId
      );
      if (item) {
        return true;
      } else {
        return false;
      }
    },
  },
  /** 生命周期 - 创建完成（可以访问当前this实例） */
  created () {
    this.InitData();
  },
  /** 生命周期 - 挂载完成（可以访问DOM元素） */
  mounted () {
    this.getDepts();
    this.getUsers();
    this.$refs.AssetInfoEditRef.getFixedAssetList();
  },
  /** 生命周期 - 创建之前 */
  beforeCreate () { },
  /** 生命周期 - 挂载之前 */
  beforeMount () { },
  /** 生命周期 - 更新之前 */
  beforeUpdate () { },
  /** 生命周期 - 更新之后 */
  updated () { },
  /** 生命周期 - 销毁之前 */
  beforeDestroy () { },
  /** 生命周期 - 销毁完成 */
  destroyed () { },
  /** 如果页面有keep-alive缓存功能，这个函数会触发 */
  activated () { },
};
</script>

<style lang="scss" scoped>
.addCertificateBtn {
  color: #286ab4;
  font-weight: bold;
  font-size: 15px;
  img {
    height: 15px;
    position: relative;
    top: 2px;
    cursor: pointer;
  }
  span {
    cursor: pointer;
  }
}
.certificateState {
  margin-left: 20px;
  font-size: 14px;
}
.show-files {
  width: 50%;
  text-align: center;
  color: #286ab4;
  cursor: pointer;
}
</style>
